import { __awaiter } from "tslib";
import { fetchActiveNotifications } from 'pathfinder/api/marketingNotifications';
const ACTIVE_CMS_NOTIFICATIONS = 'active_cms_notifications';
export const LOCAL_STORAGE_TTL = 900000;
export const getAllActiveNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
    const localStorageNotificationsData = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(ACTIVE_CMS_NOTIFICATIONS);
    if (localStorageNotificationsData) {
        const parsedNotificationsData = JSON.parse(localStorageNotificationsData);
        const now = new Date();
        if (now.getTime() <= parsedNotificationsData.expiry) {
            return Promise.resolve(parsedNotificationsData.value);
        }
    }
    const activeNotifications = yield fetchActiveNotifications();
    if (activeNotifications) {
        const now = new Date();
        const activeNotificationsObject = {
            value: activeNotifications,
            expiry: now.getTime() + LOCAL_STORAGE_TTL,
        };
        try {
            localStorage.setItem(ACTIVE_CMS_NOTIFICATIONS, JSON.stringify(activeNotificationsObject));
        }
        catch (_a) {
            console.warn(`Can't write  ${ACTIVE_CMS_NOTIFICATIONS} to localStorage. Seems like LS is disabled.`);
        }
        return activeNotifications;
    }
});
